import { DatePipe, SlicePipe } from '@angular/common';
import { Component } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-notifications-outlet',
    template: `
        <!-- Ein hoher baseZIndex Wert stellt sicher das Notfications im Vordergrund bleiben -->
        <p-toast position="top-center" styleClass="w-auto"></p-toast>
        <p-toast key="error" position="center" styleClass="general-error">
            <ng-template let-message pTemplate="message">
                <div class="p-2 w-full">
                    <h2>Es ist ein Systemfehler aufgetreten!</h2>
                    <h3>Technische Details:</h3>

                    <div class="form-container" style="align-items: normal">
                        <label>Zeit</label>
                        <span>{{ message.data.timestamp | date: 'medium' }}</span>

                        <label>URL</label>
                        <span>{{ message.data.url }}</span>

                        <label>Status</label>
                        <span>{{ message.data.status }}</span>

                        @if (message.data.message) {
                            <label>Message</label>
                            <span style="word-wrap: break-word; max-height: 60vh; overflow: hidden auto">{{ message.data.message }}</span>
                        }

                        @if (message.data.node) {
                            <label>Node</label>
                            <span>{{ message.data.node }}</span>
                        }

                        @if (message.data.correlationId) {
                            <label>Correlation Id</label>
                            <span>{{ message.data.correlationId }}</span>
                        }

                        @if (message.data.sessionId) {
                            <label>Session Info</label>
                            <span>{{ message.data.sessionId }}</span>
                        }

                        @if (message.data.stacktrace) {
                            <label>Stacktrace</label>
                            <!-- Bringen uns die Client-seitigen Stacktraces was? Sind sehr sehr lang -->
                            <span style="word-wrap: break-word">{{ message.data.stacktrace | slice: 0 : 500 }}</span>
                        }
                    </div>
                </div>
            </ng-template>
        </p-toast>
    `,
    standalone: true,
    imports: [ToastModule, SharedModule, SlicePipe, DatePipe],
})
export class NotificationsOutletComponent {}
